import { useQuery } from '@tanstack/react-query';

import {
  FindProductFamiliesIncludeProductsAndDiesArgs,
  FindProductFamiliesIncludeProductsAndDiesResult,
  FindProductFamilyByIdIncludeProductsAndDiesResult,
} from '@app/domain-interfaces';
import { CommonFindResult } from '@app/infra-interfaces';
import { Axios } from '@app/web-components';

export const PRODUCT_FAMILY_ALL_QUERY_KEY = 'PRODUCT_FAMILY_ALL_QUERY_KEY';

export const productFamilyKeys = {
  all: [PRODUCT_FAMILY_ALL_QUERY_KEY] as const,
  lists: () => [...productFamilyKeys.all, 'list'] as const,
  list: (filters: object) => [...productFamilyKeys.lists(), filters] as const,
  details: () => [...productFamilyKeys.all, 'detail'] as const,
  detail: (id: number) => [...productFamilyKeys.details(), id] as const,
};

const BASE_URL = '/product-families';

export const useFindProductFamilyById = ({ productFamilyId }: { productFamilyId: number }) => {
  const axios = Axios.useAxiosApi();

  return useQuery<FindProductFamilyByIdIncludeProductsAndDiesResult>({
    queryKey: productFamilyKeys.detail(productFamilyId),
    queryFn: async () => {
      const { data } = await axios.get(`${BASE_URL}/${productFamilyId}`);
      return data;
    },
  });
};

export const useFindProductFamilies = (body: FindProductFamiliesIncludeProductsAndDiesArgs) => {
  const axios = Axios.useAxiosApi();

  return useQuery<CommonFindResult<FindProductFamiliesIncludeProductsAndDiesResult>>({
    queryKey: productFamilyKeys.list(body),
    queryFn: async () => {
      const { data } = await axios.post(`${BASE_URL}/find`);
      return data;
    },
  });
};
